import { useState, useEffect } from "react";

export const useTiempo = (contador, tiempo_espera) => {

    const [estatus, setEstatus] = useState(null);

    useEffect(() => {
        setEstatus(validarTiempoEspera(contador));

        return () => setEstatus(null);
    }, [contador]);

    const validarTiempoEspera = (tiempo) => {
        const [horas, minutos] = tiempo?.split(':');

        if(Number(horas) > 0) return 2;
        if(Number(minutos) >= (Number(tiempo_espera) - 2) && Number(minutos) < Number(tiempo_espera)) return 1;
        if(Number(minutos) >= Number(tiempo_espera)) return 2;

        return 0;
    }

    return {
        estatus
    }
};